export default "__VITE_ASSET__BeHmgiP0__"